// extracted by mini-css-extract-plugin
module.exports = {"bg":"Charity-module--bg--3P7Xt","card":"Charity-module--card--39vqT","list":"Charity-module--list--3Z7hO"};